/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameDescriptionModel } from '../../models/name-description-model';

export interface GetAntecedentStrategyTemplates$Params {
  patientID?: number;
}

export function GetAntecedentStrategyTemplates(http: HttpClient, rootUrl: string, params?: GetAntecedentStrategyTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDescriptionModel>>> {
  const rb = new RequestBuilder(rootUrl, GetAntecedentStrategyTemplates.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameDescriptionModel>>;
    })
  );
}

GetAntecedentStrategyTemplates.PATH = '/api/Staff/GetAntecedentStrategyTemplates';
